export const depositsTypeText = {
    "001": "deposits.depositType.nonTransferable",
    "002": "deposits.depositType.nonTransferableUSD",
};

export const renewalActions = ["renewal", "renewalWithInterest"];

export default depositsTypeText;
